import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { SingleCheckoutComponentComponent } from 'src/app/shared/modals/single-checkout-component/single-checkout-component.component';
import { TemplateDocumentType } from '../../models/document/document-template-model';
import { ProductType } from '../../models/cart/product-info-model';


@Injectable({
  providedIn: 'root'
})
export class CheckoutModalService {

  @Output() modelChanged = new EventEmitter<any>();

  constructor(private modalService: NgbModal) { }
  //asd
  openModal(model: any, templateType?: TemplateDocumentType, productType?: ProductType) {
    var modalRef!: NgbModalRef;
    modalRef = this.modalService.open(SingleCheckoutComponentComponent, { windowClass: "customModalClassUnderName", size: 'lg', backdrop: 'static', keyboard: false });

    if (templateType !== undefined && templateType === TemplateDocumentType.Marketplace) {
      //enable stripe payment Checkout

      if (productType == ProductType.WalletTopUp) {
        modalRef.componentInstance.stripePayment = true;

        modalRef.componentInstance.singlePackageCheckout = model;
      } else {
        modalRef.componentInstance.stripePayment = true;

        modalRef.componentInstance.singlePackageCheckout = model;
      }

    } else {
      modalRef.componentInstance.singleRequisitionModel = model;
    }
    var sub: Subscription = modalRef.closed.subscribe(() => {
      if (templateType !== undefined && templateType === TemplateDocumentType.Marketplace) {
        this.modelChanged.emit(modalRef.componentInstance.checkoutSucceeded)
      } else {
        this.modelChanged.emit(modalRef.componentInstance.singleRequisitionModel)
      }
      sub.unsubscribe();
    })
  }
}
